// React
import React, { useState, useRef } from "react";

// React Async
import Async from "react-async";

// Components
import { Form } from "react-bootstrap";
import {
  ProgressBar,
  Modal,
  Button,
  Table,
  Row,
  Col,
  Container,
  Badge
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import ListSelectionTypeahead from "../components/ListSelectionTypeahead";

// Internal Libs
import { useFormFields } from "../libs/hooksLib";
import AffinityAPI from "../libs/AffinityAPI";
import * as EventifyAPI from "../libs/EventifyAPI";
import * as ModelCache from "../libs/ModelCache";

// CSV
import parse from "csv-parse";

// AWS
import config from "../config";
import { API, Auth } from "aws-amplify";

// Local Storage
import ls from "local-storage";

// UUID
const uuidv4 = require("uuid/v4");

export default function YNPUploaderModal(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [uploadButtonTitle, setUploadButtonTitle] = useState("Upload YNP");
  const [useExistingList, setUseExistingList] = useState(true);
  const [listFileName, setListFileName] = useState(null);
  const [existingListData, setExistingListData] = useState({});
  const [existingListMembership, setExistingListMembership] = useState([]);

  const [fields, handleFieldChange] = useFormFields({
    listName: ""
  });
  const [content, setContent] = useState("");
  const [tableContent, setTableContent] = useState([]);

  // File Handle
  const file = useRef(null);

  const listNameRef = useRef(null);

  const listTypeaheadRef = useRef(null);

  // Affinity results
  var emailToAffinityId = {};

  function handleFileChange(event) {
    var newFile = event.target.files[0];
    if (newFile === null) {
      return;
    }
    file.current = event.target.files[0];
    readSingleFile(file.current);
    // var rando = {};
    // rando.target = {};
    // rando.target.id = fields.listName;
    // rando.target.value = file.current;
    // handleFieldChange(rando)
    const fileNameCleaned = file.current.name
    .replace(".csv", "")
    .replace("_", " ");
    fields.listName = fileNameCleaned;
    setListFileName(fileNameCleaned);
  }

  function validateForm() {
    return fields.listName.length > 0 && tableContent.length > 0;
  }

  function readSingleFile(e) {
    var file = e;
    if (!file) {
      return;
    }
    var reader = new FileReader();
    reader.onload = function(e) {
      var csvRaw = e.target.result;
      //
      parseCSV(csvRaw);
    };
    reader.readAsText(file);
  }

  // Ok so for this we need to do a few things.
  // 1. We need to POST each person into the database
  // 2. We need to post the enriched List to the database (originating in the tableContents datastructure)
  // 3.
  async function uploadList() {
    var list;

    if (useExistingList) {
      list = existingListData;
    } else {
      list.name = fields.listName;
      list.listid = uuidv4();

      await EventifyAPI.createList(list.listid, list.name);
    }

    var persons = [];
    var notesMap = {};
    var ynpList = [];
    var headerRow = tableContent.slice(0, 1)[0];
    headerRow.push("Affinity");

    const rowValues = tableContent.slice(1, tableContent.length);
    rowValues.forEach( (row) => {
      var personObject = {};
      personObject["personid"] = uuidv4();
      var headerK = 0;
      var previouslyUsedInviteEmail = null; // here we assume that email should always come first in the column order
      row.richArray.forEach( (datum) => {
        const headerValue = headerRow[headerK];
        const headerValueLowerCase = headerValue.toLowerCase();
        const rawDatum = datum.raw.trim();
        if (headerValueLowerCase === "name") {
          const nameValue = rawDatum === "" ? null : rawDatum;
          if (nameValue != null) {
            personObject[headerValueLowerCase] = nameValue;
          }
        } else if (headerValueLowerCase === "email") {
          const emailValue = rawDatum === "" ? null : rawDatum;
          if (emailValue != null) {
            previouslyUsedInviteEmail = emailValue;
            personObject[headerValueLowerCase] = emailValue;
          }
        } else if (headerValueLowerCase === "comments" || headerValueLowerCase === "notes") {
          const notes = rawDatum === "" ? null : rawDatum;
          if (notes != null) {
            const notesObj = { listid: list.listid, personid: personObject.personid, notes: notes };
            notesMap[personObject.personid] = notesObj;
          }
        } else if (headerValueLowerCase === "status") {
          const ynp = rawDatum === "" ? null : rawDatum;
          if (ynp !== null && typeof ynp !== "undefined" && ynp !== "") {
            const ynpObj = { listid: list.listid, personid: personObject.personid, ynp: ynp };
            ynpList.push(ynpObj);
          }
        }
        headerK++;
      });
      // if (previouslyUsedInviteEmail != null) {
      //   const affinityIdentityData = emailToAffinityId[previouslyUsedInviteEmail];
      //   if (affinityIdentityData != null && affinityIdentityData.doesNotExist === false)  {
      //     const affinityData = affinityIdentityData.foundMatchedPerson;
      //     personObject["affinity"] = affinityData;
      //   }
      // }
      persons.push(personObject);
    });

    list.persons = persons;
    list.isEventList = false;

    var stalePersonIdMap = {};
    for (var k=0; k<persons.length; k++) {
      const person = persons[k];
      stalePersonIdMap[person.personid] = person.personid;
    }

    persons = await EventifyAPI.person_createMultipleIfNotExist(persons);

    // re-map stale to new
    for (var k=0; k<persons.length; k++) {
      const person = persons[k];
      const stalePersonId = person.stalePersonId;
      for (var q=0; q<ynpList.length; q++) {
          const ynpObj = ynpList[q];
          if (stalePersonId === ynpObj.personid) {
            ynpObj.personid = person.personid; // map to valid personid
            ynpList[q] = ynpObj;
            break;
          }
      }
    }

    var memberships = [];
    for (var k=0; k<persons.length; k++) {
      const personObject = persons[k];
      const membership = { personid: personObject.personid, listid: list.listid };
      memberships.push(membership);
    }

    await EventifyAPI.addMultiplePeopleToList(memberships);

    var notesArray = [];
    for (var k=0; k<persons.length; k++) {
      const personObject = persons[k];
      const note = notesMap[personObject.stalePersonId];
      if (note !== null && typeof note !== "undefined") {
        note.personid = personObject.personid;
        notesArray.push(note);
      }
    }

    await EventifyAPI.addNotesToMultiplePersonInList(notesArray);

    await EventifyAPI.setMultipleYNP(ynpList);

  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (file.current && file.current.size > config.MAX_ATTACHMENT_SIZE) {
      alert(
        `Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE /
          1000000} MB.`
        );
        return;
      }

      // setIsLoading(true);
      // setUploadButtonTitle("Uploading List...");

      try {
        const result = await uploadList();

        window.location.reload();
      } catch (e) {
        //
        // alert(e);
        setIsLoading(false);
      }
    }

    async function parseCSV(csvRaw) {
      // manually way of doin that thang, obvi not robust, maybe useful for grabbing header metadata
      // const manuallyParsedCSV = manuallyParseCSV(csvRaw);
      // const headerValues = manuallyParsedCSV.headers;
      // const transformedValueRows = manuallyParsedCSV.rows;

      const parser = parse({
        delimiter: ','
      }, function(err, rows){
        //
        var bodyData = [];

        var found = false;
        var count = 0;
        while (found === false && count < rows.length) {
          const currentRow = rows.slice(count, count + 1)[0];
          var foundNameColumn = false;
          var foundEmailColumn = false;
          var foundPopulatedcolumns = false;
          for (var i = 0; i < currentRow.length; i++) {
            if (currentRow[i].toLowerCase().indexOf("email") !== -1) {
              foundEmailColumn = true;
            }
            if (currentRow[i].toLowerCase().indexOf("name") !== -1) {
              foundNameColumn = true;
            }
            if (foundEmailColumn && foundNameColumn) {
              found = true;
              break;
            }
          }
          if (found) {
            break;
          }
          count++;
        }

        const headerRow = rows.slice(count, count + 1);
        const valueRows = rows.slice(count + 1, rows.length + 1);

        var parsedData = headerRow;
        for (var i = 0; i < valueRows.length; i++) {
          var rowObject = {};
          var row = valueRows[i];
          var identifier = "";
          var richArray = [];
          for (var k = 0; k < row.length; k++) {
            identifier += row[k];
            var rowData = {};
            rowData.raw = row[k].trim();
            rowData.identifier = k.toString() + identifier + row[k];
            richArray.push(rowData);
            rowObject[headerRow[0][k].toLowerCase()] = rowData;
          }
          rowObject.identifier = identifier;
          rowObject.richArray = richArray;
          parsedData.push(rowObject);
        }

        setTableContent(parsedData);
      }
    );
    parser.write(csvRaw);
    parser.end();
  }

  // takes in a transformed person object and attempts to enrich it
  function renderAffinityForPerson(personInfo) {
    const fullName = personInfo.name.raw;
    const nameComponents = fullName.split(" ");
    const firstName = nameComponents[0];
    const lastName = nameComponents.slice(1, nameComponents.length).join(" ");
    const email = personInfo.email.raw;

    // const affinityData = await AffinityAPI.findAffinityMatches(firstName, lastName, email);
    return <a>Affinity Data Result</a>;
  }

  function handleAffinityLinkerResult(result) {
    emailToAffinityId[
      result.foundMatchedPerson.previouslyUsedInviteEmail
    ] = result;

    return (
      <>
      {result.doesNotExist === false ? (
        <Badge variant="info">✔ Matched</Badge>
      ) : (
        <Badge variant="light">Not Found</Badge>
      )}
      </>
    );
  }

  async function javascriptWhatTheHeck(email) {
    return emailToAffinityId[email];
  }

  function checkAffinityIfNeeded(row) {
    return async () => {
      if (emailToAffinityId[row.email.raw] == null) {
        const result = await EventifyAPI.grabAffinityDateForPerson(row.name.raw, row.email.raw);
        return result;
      } else {
        const result = await javascriptWhatTheHeck(row.email.raw);
        return result;
      }
    };
  }

  function renderCSV(csvData) {
    var headerValues = csvData.slice(0, 1);
    const rowValues = csvData.slice(1, csvData.length);

    if (headerValues.length === 1) {
      headerValues = headerValues[0];
    }

    return (
      <>
        <Table responsive>
          <thead>
            <tr>
              <th>#</th>
              {headerValues.map((headerValue, i) => (
                <th key={headerValue}>{headerValue}</th>
              ))}
              <th>Affinity</th>
            </tr>
          </thead>
          <tbody>
          {rowValues.map((row, n) => (
            <tr key={row.identifier}>
              <td key={row.identifier}>{n + 1}</td>
              {row.richArray.map((data, i) => (
                <td key={data.identifier}>{data.raw}</td>
              ))}
              <td key={row.identifier + "_affinitydata"}>
              </td>
            </tr>
          ))}
          </tbody>
        </Table>
      </>
    );
  }

  // <Async promiseFn={checkAffinityIfNeeded(row)}>
  // <Async.Pending>Loading...</Async.Pending>
  // <Async.Fulfilled>
  // {data => <div>{handleAffinityLinkerResult(data)}</div>}
  // </Async.Fulfilled>
  // <Async.Rejected>
  // {error => `Something went wrong: ${error.message}`}
  // </Async.Rejected>
  // </Async>

  async function fetchListWithId(listid) {
    ModelCache.getMembershipForListId(
      listid,
      result => {
        if (typeof result !== "undefined") {
          handleListMembershipResponse(result, listid);
        }
      }
    );
    ModelCache.getListForId(
      listid,
      result => {
        handleListInformation(result, listid);
      }
    );
  }

  function handleListMembershipResponse(result, listid) {
    console.log(result);
    setExistingListMembership(result);
  }

  function handleListInformation(result, listid) {
    setExistingListData(result);
  }

  var selectedLists = [];
  async function onUpdateListSelection(selected) {
    if (selected.length > 0) {
      fetchListWithId(selected[0].listid);
      setUseExistingList(true);
    } else {
      setUseExistingList(false);
    }
  }

  function renderExistingListTypeahead() {
    return (
      <>
        {" "}
        {useExistingList === true ? (
          <ListSelectionTypeahead
            id="listA"
            ref={listTypeaheadRef}
            onUpdate={onUpdateListSelection}
            email={props.email}
            organizationid={props.organizationid}
            multiple={false}
          />
        ) : (
          <></>
        )}{" "}
      </>
    );
  }

  return (
    <Modal
      show={props.visible}
      onHide={props.onCancel}
      animation={false}
      size="lg"
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>YNP Uploader</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Row>
                <Col>
                  <h4>Apply To Existing List</h4>
                  {renderExistingListTypeahead()}
                </Col>
                <Col>
                  <Form.Group controlId="file">
                    <Form.Label>Choose a CSV</Form.Label>
                    <Form.Control onChange={handleFileChange} type="file" />
                  </Form.Group>
                </Col>
              </Row>
            </Row>
            <Row>{renderCSV(tableContent)}</Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <LoaderButton
            block
            type="submit"
            isLoading={isLoading}
            disabled={!validateForm()}
          >
            {uploadButtonTitle}
          </LoaderButton>
          <Button variant="secondary" onClick={props.onCancel}>
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
